export default __webpack_public_path__ + "static/img/upload.7dce90e.svg";